export default __webpack_public_path__ + "static/media/requestFirstStaging.f70beac8.svg";